/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ReactivateRequestPlanSlug = typeof ReactivateRequestPlanSlug[keyof typeof ReactivateRequestPlanSlug];


export const ReactivateRequestPlanSlug = {
  solo: 'solo',
  growth: 'growth',
  business: 'business',
} as const;
